import {ValueObject} from '@s-ui/domain'

export class SearchVehiclesRequestValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {Object} params.filters
   * @param {Object} params.filters.cubicCapacity
   * @param {String} params.filters.cubicCapacity.from
   * @param {String} params.filters.cubicCapacity.to
   * @param {Array<String>} params.filters.doors
   * @param {Array<String>} params.filters.bodyTypeIds
   * @param {Array<String>} params.filters.fuelTypeIds
   * @param {Object} params.filters.hp
   * @param {String} params.filters.hp.from
   * @param {String} params.filters.hp.to
   * @param {Object} params.filters.price
   * @param {String} params.filters.price.from
   * @param {String} params.filters.price.to
   * @param {Array<Object>} params.filters.vehicles
   * @param {Object} params.pagination
   * @param {String} params.pagination.page
   * @param {String} params.pagination.size
   * @param {Object} params.sort
   * @param {String} params.sort.term
   * @param {String} params.sort.order
   */
}
